import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
const sockServer = window.LOCAL_CONFIG.endpoint.server

const Socket = {
  connected: false,
  checkTimer: null,
  clientFrame: null,
  socketFrame: null,
  checkInterval: 2000,
  connection: function (option) {
    const {OPEN, CONNECTING} = SockJS
    const isDev = option.debug === undefined ? true : option.debug
    const {clientFrame, socketFrame} = this
    if (option.checkInterval) {
      this.checkInterval = option.checkInterval
    }
    if (clientFrame && clientFrame.connected && this.connected) {
      isDev && console.warn(`[WS] Endpoint already connected`)
      return false
    }
    if (clientFrame && socketFrame.readyState === OPEN) {
      // 重新初始化
      return this.disconnection(() => { this.initialization(option) })
    }
    if (clientFrame && socketFrame.readyState === CONNECTING) {
      isDev && console.info(`[WS] Endpoint connecting......`)
      return false
    }
    // 重新初始化
    this.initialization(option)
    if (!this.checkTimer) {
      const timer = setInterval(() => {
        if (clientFrame && clientFrame.connected) {
          clearInterval(this.checkTimer)
          this.connected = true
          this.checkTimer = null
          isDev && console.info(`[WS] Endpoint reconnect successful`)
        }
        if (clientFrame && socketFrame.readyState !== CONNECTING) {
          // 断开重新初始化
          return this.disconnection(() => { this.initialization(option) })
        }
      }, this.checkInterval)
      this.checkTimer = timer
    }
  },
  initialization: function (option) {
    const me = this
    const {debug, header, success, failure} = option
    const isDev = debug === undefined ? true : debug
    const url = sockServer
    // 创建SocketJs连接
    const socket = new SockJS(url)
    this.socketFrame = socket
    // 使用STMOP子协议的WebSocket客户端
    const client = Stomp.over(socket)
    if (!isDev) {
      // 非开发模式下关闭控制台日志
      client.debug = null
    }
    client.heartbeat.outgoing = 20000
    // 客户端不从服务端接收心跳包
    client.heartbeat.incoming = 0
    const headers = header || {}
    // 开始连接服务器
    client.connect(
      headers,
      frame => {
        isDev && console.info(`[WS] Connection endpoint:${url} successful.`)
        success && success(frame)
        me.connected = true
      },
      error => { // 第一次连接失败和连接后断开连接都会调用这个函数
        isDev && console.error('[WS] Connection endpoint failure,caused by', error)
        failure && failure(error)
        me.connected = false
        setTimeout(() => {
          me.connection(option)
        }, 1000)
      }
    )
    me.clientFrame = client
  },
  disconnection: function (callback) {
    const me = this
    if (me.clientFrame) {
      me.clientFrame.disconnect(() => {
        callback && callback()
        me.connected = false
      })
    }
  },
  subscribe: function (topic, callback, header) {
    this.clientFrame.subscribe(topic, callback, header)
  },
  unsubscribe: function (topic) {
    this.clientFrame.unsubscribe(topic)
  }
}
export default Socket
